import pImg1 from '../images/apartment/apartment1.png'
import pImg2 from '../images/apartment/apartment2.png'
import pImg3 from '../images/apartment/apartment3.png'


import pSImg1 from '../images/apartment/apartment4.png'
import pSImg2 from '../images/apartment/apartment5.png'
import pSImg3 from '../images/apartment/apartment6.png'

import sIcon1 from '../images/apartment/icon1.png'
import sIcon2 from '../images/apartment/icon2.png'
import sIcon3 from '../images/apartment/icon3.png'


const Projects = [
    {
        Id: '1',
        pTitle: 'Property Overview', 
        slug: 'Property Overview',
        pImg:pImg1,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        des:'Uncover the potential of your dream home.Explore property details, features, and more.',
        width:'120',
    },
    {
        Id: '2',
        pTitle: 'PROPERTY LISTINGS', 
        slug: 'PROPERTY LISTINGS',
        pImg:pImg2,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        des:'Browse verified properties in prime locations. Find your perfect match with ease and confidence.',
        width:'130',
    },
    {
        Id: '3',
        pTitle: 'DREAM HOMES', 
        slug: 'DREAM HOMES',
        pImg:pImg3,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        des:'Explore homes tailored to your lifestyle. From budget-friendly to premium, we’ve got you covered.',
        width:'140',
    },
    {
        Id: '4',
        pTitle: 'Property Amenities', 
        slug: 'Property Amenities',
        pImg:pSImg1,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        des:'Indulge in a world of comfort and convenience.Discover the perfect blend of luxury and functionality',
        width:'120',
    },
    {
        Id: '5',
        pTitle: 'Luxury Living', 
        slug: 'Luxury Living',
        pImg:pSImg2,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        des:'Indulge in the epitome of refined living.Experience splendour and comfort at its finest.',
        width:'130',
    },
    {
        Id: '6',
        pTitle: 'Modern Home', 
        slug: 'Modern Homes',
        pImg:pSImg3,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        des:'Discover contemporary living spaces.Sleek designs meet modern comfort',
        width:'140',
    }
]

export default Projects;